import { FC, createElement, useEffect } from 'react';

interface ICalculatorState {
  regionId?: number;
  loanTerm?: number;
  propertyAmount?: number;
  initialPayment?: number;
  interestRate?: number;
  interestRateSuggests?: string;
  onSendFormButtonClick?(): void;
}

export const CalculatorComponent: FC<ICalculatorState> = widgetState => {
  useEffect(() => {
    if (typeof document !== 'undefined' && document.querySelector) {
      const widgetJs = '//static.cdn-cian.ru/finance/mortgage-calculator-widget/widget.js';
      if (!document.querySelector(`script[src="${widgetJs}"]`)) {
        const script = document.createElement('script');
        script.src = widgetJs;
        script.async = true;
        document.head.appendChild(script);
      }
    }
  }, []);

  return createElement('mortgage-calculator', widgetState);
};
